import SvgIcon from '@mui/material/SvgIcon';

interface Props {
  isSelected: boolean;
}

export const CardsTableHeadArrowDown = ({ isSelected }: Props) => {
  const fill = !isSelected ? '#656565' : '#D9D9D9';
  return (
    <SvgIcon sx={{ width: 6, height: 4 }}>
      <svg
        width="6"
        height="4"
        viewBox="0 0 6 4"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.99658 3L0.400616 1.25622e-08L5.59254 -4.417e-07L2.99658 3Z"
          fill={fill}
        />
      </svg>
    </SvgIcon>
  );
};
